import { Box, Flex, Image, Link } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import logoImage from '@/travo/assets/images/shared/logo-with-text.svg';
import { useCopy } from '@/travo/i18n';
import { DesktopNav } from './DesktopNav';
import { MobileNav } from './MobileNav';
import { useNavItems } from './useNavItems';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const copy = useCopy();
  const { homePath } = useNavItems();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={1000}
      bg="paper"
      borderBottom="2px solid"
      borderColor={isScrolled ? 'ink' : 'transparent'}
      transition="border-color 0.2s"
    >
      <Flex justify="space-between" align="center" maxW="1240px" mx="auto" px={{ base: 4, md: 6 }} py="14px" gap={4}>
        <Flex align="center" gap="14px" minW={0}>
          <Link asChild aria-label={copy.nav.home} display="flex" flexShrink={0}>
            <RouterLink to={homePath}>
              <Image src={logoImage} h={{ base: '38px', lg: '44px' }} alt="Travo" />
            </RouterLink>
          </Link>
          {/* Travo is a Travo Labs app. Hidden at tablet widths, where the nav needs the room. */}
          <Link
            asChild
            display={{ base: 'inline', md: 'none', xl: 'inline' }}
            fontFamily="mono"
            fontSize="12px"
            letterSpacing="0.06em"
            color="inkSoft"
            textDecoration="none"
            whiteSpace="nowrap"
            _hover={{ color: 'stampDeep' }}
          >
            <RouterLink to="/">{copy.nav.byLabs}</RouterLink>
          </Link>
        </Flex>

        <DesktopNav />
        <MobileNav isOpen={isMobileMenuOpen} onToggle={setIsMobileMenuOpen} />
      </Flex>
    </Box>
  );
};

export default Header;
